import { render, staticRenderFns } from "./websettings.vue?vue&type=template&id=2e88c523&"
import script from "./websettings.vue?vue&type=script&lang=js&"
export * from "./websettings.vue?vue&type=script&lang=js&"
import style0 from "./websettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports